const faq_pt = require('./faq.json')
export default faq_pt